import { buildLookupOptions, lookupbox } from "../poiagg";
import { store } from "~/state/store";
import { SATURATION_MAPSETS } from "~/util/constants";
import Scene from "~/scene";

export default class PoiaggLookupbox {
	_mapset: number;

	_request: any;

	_opts: any;

	constructor() {
		this._mapset = 0;
		this._request = null;
		this._opts = {};
	}

	set mapset(mapset: number) {
		this._mapset = mapset;
	}

	updateOpts(opts: any) {
		this._opts = opts;
	}

	lookupbox() {
		if (this._request) {
			this._request.abort();
			this._request = null;
		}

		const lookupOpts = buildLookupOptions(this._mapset, {
			zoomCorrection: () => {
				const msState = store.getState().map;
				const search = Mapy.getComponent("search");
				// jen an mapsetech se saturaci a pokud se jedna o zapnute letecke snimky, tak budeme zoom pro lookup posouvat
				const validMapset = SATURATION_MAPSETS.indexOf(msState.mapset) > -1 || msState.mapset === "letecka";

				return Mapy.active[0] === search
					&& search.isActive()
					&& search.hasResults()
					&& validMapset
					&& msState.zoom > 7
					? -2
					: 0;
			},
			...this._opts,
		});
		const viewport = Scene.getViewport();
		const lookupboxData = lookupbox(viewport.lbx, viewport.lby, viewport.rtx, viewport.rty, lookupOpts);

		this._request = lookupboxData.request;

		return lookupboxData.promise;
	}
}
